module.exports = __webpack_public_path__ + "static/media/latam-gold.0e1e6536.png";